import { SVGProps, Ref, forwardRef } from 'react';

export const HumanCircleOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M11.334 6.733a.7.7 0 0 1 0 1.4H9.543l.733 3.851a.7.7 0 0 1-1.375.262l-.408-2.145h-.99L7.1 12.23a.7.7 0 0 1-1.375-.261l.73-3.836H4.667a.7.7 0 0 1 0-1.4z"
                    fill="currentColor"
                />
                <path
                    d="M8 3c.548 0 .942.185 1.195.488.248.297.338.682.338 1.045s-.09.747-.338 1.044c-.253.304-.647.49-1.195.49s-.942-.186-1.195-.49c-.248-.297-.338-.681-.338-1.044s.09-.748.338-1.045C7.058 3.185 7.452 3 8 3"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5c5.625 0 7.5 3.75 7.5 7.5s-1.875 7.5-7.5 7.5S.5 11.75.5 8 2.375.5 8 .5m0 1.4c-2.476 0-3.925.81-4.784 1.84C2.319 4.816 1.9 6.333 1.9 8s.42 3.184 1.316 4.26C4.076 13.29 5.524 14.1 8 14.1s3.925-.81 4.784-1.84C13.681 11.184 14.1 9.667 14.1 8s-.42-3.184-1.316-4.26C11.924 2.71 10.476 1.9 8 1.9"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HumanCircleOutlinedSize16Glyph.displayName = 'HumanCircleOutlinedSize16Glyph';
